var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "room-info-container" }, [
        _c("div", { staticClass: "info-title-container" }, [
          !_vm.isMobile
            ? _c("img", {
                staticClass: "info-title-logo",
                attrs: {
                  src: require("@/assets/images/camstudy/logo_gooroomee_blue_016FF2.svg"),
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "room-title" }, [
            _vm._v(_vm._s(_vm.room.title || _vm.camStudyInfo.studyTitle)),
          ]),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "person-count" }, [
            _vm._v(_vm._s(_vm.roomUserCount)),
          ]),
          _c("div", { staticClass: "info-icon-container" }, [
            _vm._m(0),
            _c("div", {
              staticClass: "toggle-open-detail",
              class: { active: _vm.isOpenDetail },
              on: { click: _vm.onToggleOpenDetail },
            }),
          ]),
        ]),
      ]),
      _c(
        "transition",
        { attrs: { name: "menu-slide-top-bottom", tag: "div" } },
        [
          _vm.isOpenDetail
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.isMobile ? null : _vm.onCloseOpenDetail,
                      expression: "isMobile ? null : onCloseOpenDetail",
                    },
                  ],
                  staticClass: "info-detail-container",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  !_vm.isMobile
                    ? _c(
                        "div",
                        { staticClass: "info-detail-container-title" },
                        [
                          _c("div", {
                            staticClass: "close-btn",
                            on: { click: _vm.onCloseOpenDetail },
                          }),
                          _c("div", [_vm._v("스터디 정보")]),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "column-container" }, [
                    _c("div", { staticClass: "column-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.coordi.roomInfo.studyTitle"))
                      ),
                    ]),
                    _c("div", { staticClass: "column-message" }, [
                      _vm._v(
                        _vm._s(_vm.room.title || _vm.camStudyInfo.studyTitle)
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "column-container" }, [
                    _c("div", { staticClass: "column-title" }, [
                      _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.host"))),
                    ]),
                    _vm.camStudyUser.profileImageUrl
                      ? _c("img", {
                          staticClass: "column-profile-image",
                          attrs: {
                            src: _vm.camStudyUser.profileImageUrl || "",
                            alt: "image",
                          },
                        })
                      : _c("div", { staticClass: "profile-image-none" }),
                    _c("div", { staticClass: "column-message" }, [
                      _vm._v(_vm._s(_vm.camStudyUser?.username)),
                    ]),
                  ]),
                  _c("div", { staticClass: "column-container" }, [
                    _c("div", { staticClass: "column-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.coordi.roomInfo.capacity"))
                      ),
                    ]),
                    _c("div", { staticClass: "column-message" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("camstudy.coordi.roomInfo.participants", {
                              0: _vm.room.maxCnt,
                            })
                          )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "column-container" }, [
                    _c("div", { staticClass: "column-title" }, [
                      _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.period"))),
                    ]),
                    _c("div", { staticClass: "column-message" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formatStartDate) +
                          " ~ " +
                          _vm._s(_vm.formatEndDate)
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "column-container" }, [
                    _c("div", { staticClass: "column-title" }, [
                      _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.notice"))),
                    ]),
                    _c("div", { staticClass: "column-message" }, [
                      _vm._v(_vm._s(_vm.camStudyInfo.studyContent)),
                    ]),
                  ]),
                  _c("div", { staticClass: "warning-container" }, [
                    _c("div", { staticClass: "warning-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.coordi.roomInfo.reportTitle"))
                      ),
                    ]),
                    _c("div", { staticClass: "warning-message" }, [
                      _vm._v(
                        _vm._s(_vm.$t("camstudy.coordi.roomInfo.reportMessage"))
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "more-detail",
                        on: { click: _vm.onOpenMoreDetailModal },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("camstudy.coordi.roomInfo.moreDetail.title")
                          )
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          href: "https://webchat.thecloudgate.io/webChat?brandKey=MUxOPwt-6RJvxjfghABUmA&channelType=scenario&scenarioId=MzI3OQ",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/images/camstudy/ico_help_white.svg"),
            alt: "문의",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }